module.exports = __webpack_public_path__ + "ofis 3.jpg?268b36349f5427008ca41f2c5e14cffd";


//////////////////
// WEBPACK FOOTER
// ./src/HtmlFiles/img/ofis 3.jpg
// module id = 355
// module chunks = 0